<template>
  <div class="flex flex-row gap-x-2 relative">
    <div class="relative flex-1">

      <!-- Image -->
      <div class="absolute top-0 bottom-0 left-0 flex items-center pl-5">
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none">
          <path d="M1.40996 17.2284C1.55656 18.6879 2.72343 19.8664 4.20186 20.0577C5.91559 20.2794 7.6871 20.5 9.5 20.5C11.3129 20.5 13.0844 20.2794 14.7981 20.0577C16.2766 19.8664 17.4434 18.6879 17.59 17.2284C17.792 15.2181 18 13.1348 18 11C18 9.74477 17.9281 8.50736 17.8278 7.29215C17.5864 4.36854 15.211 1.92579 12.2425 1.64334C11.3406 1.55752 10.4257 1.5 9.5 1.5C7.6871 1.5 5.91559 1.72061 4.20186 1.94234C2.72343 2.13362 1.55656 3.31212 1.40995 4.77163C1.20802 6.78186 1 8.86517 1 11C1 13.1348 1.20803 15.2181 1.40996 17.2284Z" fill="white" stroke="#999999" stroke-width="2"/>
          <path d="M11.1169 4.53999V7.86003H14.9096C16.5965 7.86003 17.9677 9.18905 17.9999 10.8405C17.9942 9.63996 17.9242 8.45588 17.8281 7.29215C17.5868 4.36854 15.2114 1.92579 12.2429 1.64334C11.3409 1.55752 10.426 1.5 9.50033 1.5C9.13883 1.5 8.77898 1.50877 8.4209 1.52458C9.94146 1.71531 11.1169 2.99264 11.1169 4.53999Z" fill="#F7F7F7" stroke="#999999" stroke-width="2" stroke-linejoin="round"/>
        </svg>
      </div>

      <!-- Input -->
      <input disabled type="text" class="w-full text-[14px] lg:text-[22px] bg-[#F7F7F7] border border-[#999] rounded-[16px] py-3 pl-16 pr-28 md:text-[16px] md:py-3 md:pl-14 md:pr-24 placeholder:text-[14px] lg:placeholder:text-[18px] placeholder:font-medium placeholder:text-[#999] focus:outline-[#7639DF]" v-model="name" placeholder="파일을 선택해 주세요">

      <input ref="file" style="display: none"  type="file" @change="filesSelected"></input>
      <div class="absolute top-1/2 right-14 transform -translate-y-[50%] md:right-12">
        <span class="text-[22px] text-[#666] md:text-[16px]">{{size}}</span>
      </div>

      <!-- Delete -->
      <a @click="name='', size=''" class="absolute top-1/2 right-4 transform -translate-y-[50%]">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-[34px] h-[34px] md:w-[22px] md:h-[22px]" viewBox="0 0 34 35" fill="none">
          <ellipse cx="16.9998" cy="17.4893" rx="15.5833" ry="14.96" fill="#999999"/>
          <path d="M12.4165 21.6089L22.2326 12.3809" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M22.2334 21.6089L12.4173 12.3809" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>

    </div>
    <button @click="$refs.file.click()" class="flex-shrink-0 text-[20px] font-semibold text-[#222] bg-[#FFD85D] border border-[#222] rounded-[16px] p-4 md:text-[14px] md:py-3">파일선택</button>
    <div class="w-full absolute flex items-center bottom-[-20px] start-0" v-if="percentCnt > 0">
      <div class="flex-auto">
        <div v-bind:style="{width: percentCnt + '%'}" class="rounded-[20px] border-[3px] h-[0px] border-[#7639DF]"></div>
      </div>
      <div class="text-[13px]/[16px] ms-[6px]">{{percentCnt}} %</div>
    </div>
  </div>
</template>
<script>
import Axios from 'axios'
export default {
  // ...
  data: function(){
    return {
      percentCnt: 0,
      fileRecords: []
      , listFiles:[]
      , detail : {}
      , selectText :  "파일을 선택해주세요"
      , errorMessage : "이 형식은 이미지형식이 아닙니다."
      , errorSize : "사이즈가 400MB가 넘습니다."
      , maxFiles : 8
      , cnt : 0
      , name : ''
      , size : ''
    };
  },
  props:['listimgfile'],
  mounted:function(){
    //    // this.fileRecords = (this.listimgfile == null || this.listimgfile == undefined) ? [] : this.listimgfile;
    //    console.log("dragImg1 : ", this.listimgfile);
    //   if(this.listimgfile != null && this.listimgfile.length > 0){
    //      for(let i=0; i< this.listimgfile.length; i++){
    //          console.log("dragImg2 : ",this.listimgfile[i]);
    //          this.fileRecords.push(this.setFileRemindFromDB(this.listimgfile[i]));
    //          this.cnt++;
    //       }
    //   }

    let vm = this;

    if(vm.listimgfile != null && vm.listimgfile.length > 0){
      for(let i=0; i< vm.listimgfile.length; i++){
        vm.fileRecords.push(vm.setFileRemindFromDB(vm.listimgfile[i]));
        vm.cnt++;
      }
    }

    // if(vm.listimgfile.length > 0){
    //    for(let i=0; i< vm.listimgfile.length; i++){
    //       vm.fileRecords.push(vm.setFileRemindFromDB(vm.listimgfile[i]));
    //       vm.cnt++;
    //    }
    // }
  }
  , watch:{
    listimgfile:function(newVal, oldVal){
      let vm = this;
      vm.fileRecords = [];
      console.log("newVal : " + newVal);
      if(newVal.length > 0){
        for(let i=0; i< newVal.length; i++){
          vm.fileRecords.push(vm.setFileRemindFromDB(newVal[i]));
          vm.cnt++;
        }
      }
    }
  }
  , methods:{
    filesSelected(e){
      let vm = this;
      if(e.target.files == 0){

      }else{
        for(let i=0; i<e.target.files.length; i++){
          console.log(e.target.files[i])
          if(e.target.files[i].type.indexOf('video') > -1){
            vm.cnt++;
            console.log(e.target.files[i])
            vm.getUploadFiles(e.target.files[i], vm.cnt);
          }else{
            continue;
          }
        }
      }
    },
    fileInput(evt){
    },
    fileUpload(evt){
    }


    ,onBeforeDelete(fileRecord){
      let vm = this;
      if(confirm('삭제하시겠습니까?')){
        //     if(fileRecord.file == null){
        //          let _inner = $("#fileKey").val();
        //          let _key = $("#fileKey").val();
        //          for(let i=0; i<this.fileRecords.length; i++){
        //             if(this.fileRecords[i].filePath === fileRecord.filePath){
        //                let _path = fileRecord.filePath.split("/");
        //                let _cnt = i+1;
        //                vm.getDelete(_cnt, _path[3], "new", fileRecord.fileKey);
        //             }
        //          }
        //     }else{
        //        if(fileRecord.file.type.indexOf('image') > -1){
        //          for(let i=0; i<this.fileRecords.length; i++){
        //              if(this.fileRecords[i].file.name === fileRecord.file.name){
        //                    let _cnt = i+1;
        //                   vm.getDelete(_cnt, fileRecord.file.name, "new");

        //              }
        //          }
        //       }
        //  }

        let _inner = $("#fileKey").val();
        let _key = $("#fileKey").val();
        for(let i=0; i<this.fileRecords.length; i++){
          if(this.fileRecords[i].filePath === fileRecord.filePath){
            let _path = fileRecord.filePath.split("/");
            let _cnt = i+1;
            vm.getDelete(_cnt, _path[3], "new", fileRecord.fileKey);
          }
        }
        this.$refs.fileAgent.deleteFileRecord(fileRecord);
      }

    }
    , onDelete(evt){
    }
    ,getDelete(_cnt, _name, type, fileKey){
      let vm = this;
      let _form = new FormData();
      let _inner = (fileKey != null) ? fileKey : $("#fileKey").val();
      let _key = $("#fileKey").val();
      let usrKey = $("#usrKey").val();
      _form.append('paramUid', usrKey);
      _form.append('paramText', _name);
      _form.append('resultData', _cnt);
      _form.append('defaultView', _inner);
      _form.append('statusCode', type);

      Axios.post("/api/img/delete", _form, { headers: { 'Content-Type': 'multipart/form-data' }
      }).then(function(response) {
        vm.cnt--;
      }).catch(function(ex) {
        console.log(ex);
      });
    }
    ,setFileRemindFromFile(_data){
      console.log(_data);
      return  {
        name : _data.name,
        sizeText :_data.sizeText,
        size : _data.size,
        type : _data.type,
        ext : _data.ext,
        // width : _data.dimensions.width,
        // height : _data.dimensions.height,
        color : _data.color
      };

    }
    ,setFileRemindFromDB(_data){
      console.log("_data",_data);
      if (!_data.file_org_name) return {};
      return  {
        name : _data.file_org_name,
        sizeText :_data.sizeText,
        size : _data.size,
        type : _data.filetype,
        ext : _data.fileExt,
        filePath: '/video/' + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
        //url: "http://localhost:8080/img/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
        url: "/video/" + _data.file_new_name.substring(0,8) + "/" + _data.file_new_name,
        fileKey: _data.cmm_sprt,
        //urlResized: _data.imgBase64,
        lastModified: 1583992794341
      };
    }
    ,getUploadFiles(evt, cnt){
      let vm = this;
      let _inner = $("#fileKey").val();
      let _key = $("#fileKey").val();
      let _form = new FormData();
      let _data = vm.setFileRemindFromFile(evt);

      let _param = _data;

      _form.append('uploadFiles', evt);
      _form.append('paramText', _key);
      _form.append('resultData', vm.cnt);
      _form.append('defaultView', _inner);
      _form.append('reason', 'image');
      _form.append('paramOption', JSON.stringify(_param) );

      Axios.post("/api/video/upload", _form, { headers: { 'Content-Type': 'multipart/form-data' }
      ,onUploadProgress: (progressEvent) => {
          vm.percentCnt = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
      }).then(function(response) {
        vm.name = evt.name;
        if (evt.size >= 1000000) {
          vm.size = Math.ceil(evt.size / 1000000) + 'MB'
        } else if (evt.size >= 1000) {
          vm.size = Math.ceil(evt.size / 1000) + 'KB'
        } else {
          vm.size = (evt.size) + 'B'
        }
        vm.listimgfile.push({a:1})
      }).catch(function(ex) {
        console.log(ex);
      });
    }

    , onchanged(){
    }

    , onMaxChange(max){
      this.maxFiles = max;
    }
  }
}
</script>
